module.exports = __webpack_public_path__ + "static/img/authen.5e4b85ef.png";